import React, { ReactElement } from 'react';
import PasswordVerification from '../shared/PasswordVerification';

interface ActivateUserInviteProps {
  email: string;
}

const ActivateUserInvite = ({
  email,
}: ActivateUserInviteProps): ReactElement => (
  <div className="space-y-6">
    <h2 className="text-left text-3xl font-semibold text-gray-900">
      Create Account
    </h2>
    <span className="block text-sm font-semibold text-gray-900">{email}</span>
    <PasswordVerification
      isInSettings={false}
      isRequired={true}
      submitButtonText="Sign Up"
    />
  </div>
);

export default ActivateUserInvite;
